/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApplicationWhitelistDto } from '../models/ApplicationWhitelistDto';
import type { EntityModelResponseContainerApplicationWhitelistDto } from '../models/EntityModelResponseContainerApplicationWhitelistDto';
import type { PagedModelEntityModelApplicationWhitelistDto } from '../models/PagedModelEntityModelApplicationWhitelistDto';
import type { PagedResourcesAssemblerApplicationWhitelistDto } from '../models/PagedResourcesAssemblerApplicationWhitelistDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ApplicationWhitelistControllerService {
    /**
     * @returns PagedModelEntityModelApplicationWhitelistDto OK
     * @throws ApiError
     */
    public static list({
        assembler,
        page,
        size = 20,
        sort,
    }: {
        assembler: PagedResourcesAssemblerApplicationWhitelistDto,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
    }): CancelablePromise<PagedModelEntityModelApplicationWhitelistDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/whitelists',
            query: {
                'page': page,
                'size': size,
                'sort': sort,
                'assembler': assembler,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerApplicationWhitelistDto OK
     * @throws ApiError
     */
    public static create({
        requestBody,
    }: {
        requestBody: ApplicationWhitelistDto,
    }): CancelablePromise<EntityModelResponseContainerApplicationWhitelistDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/program/whitelists',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns EntityModelResponseContainerApplicationWhitelistDto OK
     * @throws ApiError
     */
    public static getInfoFromApk({
        requestBody,
    }: {
        requestBody: ApplicationWhitelistDto,
    }): CancelablePromise<EntityModelResponseContainerApplicationWhitelistDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/program/whitelists/get_info_from_apk',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static delete({
        packageName,
    }: {
        packageName: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/program/whitelists/{packageName}',
            path: {
                'packageName': packageName,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerApplicationWhitelistDto OK
     * @throws ApiError
     */
    public static read({
        packageName,
    }: {
        packageName: string,
    }): CancelablePromise<EntityModelResponseContainerApplicationWhitelistDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/whitelists/{packageName}',
            path: {
                'packageName': packageName,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerApplicationWhitelistDto OK
     * @throws ApiError
     */
    public static update({
        packageName,
        requestBody,
    }: {
        packageName: string,
        requestBody: ApplicationWhitelistDto,
    }): CancelablePromise<EntityModelResponseContainerApplicationWhitelistDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/program/whitelists/{packageName}',
            path: {
                'packageName': packageName,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
